export default "__VITE_ASSET__DzVt6wRY__"